module.exports = __webpack_public_path__ + "media/images/pc/stores/hiroshima/hiroshima_concept_02-3a74d96e2f50f1e23d5ca4c8fd3eb52d.jpg";